import { render } from "./caseToImg.vue?vue&type=template&id=0c6bddb7&scoped=true"
import script from "./caseToImg.vue?vue&type=script&lang=js"
export * from "./caseToImg.vue?vue&type=script&lang=js"

import "./caseToImg.vue?vue&type=style&index=0&id=0c6bddb7&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-case/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6bddb7"]])

export default __exports__